import _ from 'lodash';
import moment from 'moment-timezone';
import { arrayAny } from '../../utils/arrayUtils';

export const getFileFormat = (key, fileFormats) => _.find(fileFormats, f => f && f.key === key);

export const filterByApplicationAreas = (areas, docTypes) => {

    // areas ~ ['landlord'] or ['landlord', 'properties'] etc
    // docTypes == unfiltered list of all docTypes
    const result = _.filter(docTypes, d => arrayAny(_.intersection(d.applicationAreas, areas)))
    return result;

};

export const allowableDocTypes = (existingDocs, docTypes) => {

    const today = moment();
    const daysDifference = givenDate => moment(givenDate).diff(today, 'days');

    const allowableTypes = [];

    const noneExist = dt => _.filter(existingDocs, d => d.documentType.documentType === dt.documentType).length < 1;

    const canAdd = dt => {
        const docsOfSuppliedType = _.filter(existingDocs, d => d.documentType.documentType === dt.documentType);
        const expiringSoon = _.filter(docsOfSuppliedType, d => daysDifference(d.expiry) <= 60).length;

        return expiringSoon > 0 || noneExist(dt);

    };

    for (const dt of docTypes) {

        if (dt.allowMultiple || canAdd(dt)) {
            allowableTypes.push(dt);
        }
    }
    return allowableTypes;
};